function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useRef } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { ColumnInfoBlock } from "../ColumnInfoBlock";
import { EntryAnimation } from "../../atoms";
export default function ColumnInfoGroup(param) {
    var _param_sortDirection = param.sortDirection, sortDirection = _param_sortDirection === void 0 ? "horizontal" : _param_sortDirection, entries = param.entries, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-8 grid-cols-1 grid-flow-row auto-rows-max md:gap-10"
    }, entries.map(function(_param, index) /*#__PURE__*/ {
        var entryClassName = _param.className, entry = _object_without_properties(_param, [
            "className"
        ]);
        return React.createElement(EntryAnimation, {
            key: "entry-".concat(entry.title),
            view: containerRef,
            delay: index / 10,
            className: twMerge("scroll-mt-12", entryClassName)
        }, /*#__PURE__*/ React.createElement(ColumnInfoBlock, _object_spread({
            sortDirection: sortDirection
        }, entry)));
    })));
}

//# sourceMappingURL=ColumnInfoGroup.js.map